import React from 'react';
import PropTypes from 'prop-types';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer,
  Cell 
} from 'recharts';

const RecaudacionMensualChart = ({ data = [] }) => {
  return (
    <div  className="statistics-chart" style={{marginTop:20}}>
      <div className="chart-header">
        <h3 className="statistics-title">Ingresos Mensuales</h3>
      </div>
      
      <div style={{ width: '100%', height: 300, marginTop: '20px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
            
            <XAxis 
              dataKey="mes_nombre" 
              axisLine={false} 
              tickLine={false} 
              tick={{ fontSize: 12, fill: '#94a3b8' }} 
              dy={10}
            />
            
            <YAxis 
              axisLine={false} 
              tickLine={false} 
              tick={{ fontSize: 12, fill: '#94a3b8' }}
              tickFormatter={(value) => `$${value.toLocaleString()}`}
            />
            
            <Tooltip 
              cursor={{ fill: '#f8fafc' }}
              formatter={(value) => [`$${value.toLocaleString()}`, 'Recaudado']}
              contentStyle={{ 
                borderRadius: '12px', 
                border: 'none', 
                boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
                padding: '12px' 
              }}
            />

            <Bar 
              dataKey="total_recaudado" 
              radius={[8, 8, 0, 0]} 
              barSize={45}
            >
              {data.map((entry, index) => (
                <Cell 
                  key={entry.mes_nombre} 
                  fill={index === data.length - 1 ? '#22c55e' : '#86efac'} 
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

RecaudacionMensualChart.propTypes = {
  data: PropTypes.array,
};

export default RecaudacionMensualChart;